import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const ClassicCenter: React.FC<CoverTemplateProps> = ({
    fields,
    colors,
    logoUrl,
    showLogo,
}) => (
    <div
        className="flex size-full flex-col items-center justify-center gap-[1.6em] p-[2.4em] pt-[3.2em] text-center"
        style={{ fontFamily: COVER_DISPLAY_FONT_VAR }}
    >
        <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
        <div className="h-[1.5px] w-[5em]" style={{ backgroundColor: colors.primary }} />
        <div className="flex flex-col gap-[0.5em]">
            <div
                className="font-bold leading-[1.05] tracking-[-0.02em]"
                style={{ fontSize: coverTitleSize(2.35) }}
            >
                {fields.document_title}
            </div>
            {fields.subtitle ? (
                <div
                    className="text-[0.95em] uppercase tracking-[0.22em]"
                    style={{ color: COVER_DIM_ON_LIGHT }}
                >
                    {fields.subtitle}
                </div>
            ) : null}
        </div>
        <div className="h-[1.5px] w-[5em]" style={{ backgroundColor: colors.primary }} />
        <CoverMeta fields={fields} />
    </div>
);
